import React, { useContext } from 'react';
import { Badge, Spin, Typography } from 'antd';

import UserContext from 'components/Provider/UserProvider';
import { Link } from 'react-router-dom';
import getDynamicUrl from 'utils/getDynamicUrl';
import LoginButton from '../Login/LoginButton';
import styles from './UserAvatar.module.css';

const UserAvatar = ({ textPosition, onClick, textColor }) => {
  const { user, loading } = useContext(UserContext);
  if (loading) return null;

  if (!user) {
    return <LoginButton />;
  }

  const username = user.username ?? user.name;

  return (
    <div className={styles.wrapper} onClick={onClick}>
      {loading ? (
        <Spin />
      ) : (
        <>
          {textPosition === 'left' && (
            <Typography.Text
              ellipsis
              className="username"
              style={{
                color: textColor,
                fontSize: 16,
                marginRight: 8,
                maxWidth: 100,
              }}
            >
              {username}
            </Typography.Text>
          )}
          <Badge
            count={textPosition === 'left' ? user.openFriendRequests : 0}
            size="small"
            style={{ transform: 'translate(30%, -30%)' }}
          >
            <img className={styles.avatar} src={user.avatar} alt="avatar" />
          </Badge>
          {textPosition === 'right' && username && (
            <Link
              className={styles.userLink}
              to={getDynamicUrl(`/users/${user.username}`)}
            >
              <Typography.Text
                type="secondary"
                style={{ fontSize: 12, color: textColor }}
              >
                Logged in as
              </Typography.Text>
              <Typography.Text
                ellipsis
                style={{ color: textColor, lineHeight: 1, fontSize: 16 }}
              >
                {username}
              </Typography.Text>
            </Link>
          )}
        </>
      )}
    </div>
  );
};

export default UserAvatar;
